/* eslint-disable arrow-body-style */
import { SelectInputMulti } from '@abyss/web/ui/SelectInputMulti';
import React from 'react';
import { constants } from '@src/routes/provider/common/constants';
import {
  eventSearchFilterPanelApi,
  useEventSearchFilterPanelStore,
} from '../../mothership/eventSearchFilterPanel.state';

export const PortalsSelect = () => {
  const options = useEventSearchFilterPanelStore(
    (state) => state.portalOptions
  );
  const value = useEventSearchFilterPanelStore(
    (state) => state.portalsSelected
  );
  const loading = useEventSearchFilterPanelStore((state) => state.loading);
  const placeholder = loading ? constants.LOADING : 'Select Portals';
  const renderValue = loading ? [''] : value;

  const { setPortalValue } = eventSearchFilterPanelApi;

  return (
    <div
      data-cy="event-search-select-portals"
      data-value={value}
      data-options={JSON.stringify(options)}
      data-loading={loading}
    >
      <SelectInputMulti
        label="Portals"
        placeholder={placeholder}
        value={renderValue}
        onChange={setPortalValue}
        options={options}
        selectAll
        hideChips
        isLoading={loading}
      />
    </div>
  );
};
